import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseMiscApiService } from '@common/api/base-misc-api.service';
import { UploadFileState } from '@common/domain/models/upload-file-state';

import { AppConstants } from '../../app.constants';

@Injectable({
    providedIn: 'root'
})
export class IdenticonService extends BaseMiscApiService
{
    constructor (http: HttpClient)
    {
        super(http);

        this.segmentRoot = AppConstants.Configuration.apiUrlAuth;
        this.segmentApi = '/auth';
    }

    getAvatar (email: string): Observable<any>
    {
        return this.get(`/identicons/${email}`);
    }

    getDataUrl (email: string): Observable<string>
    {
        return this.get(`/identicons/dataurl/${email}`)
            .pipe(
                map((obj: any): string =>
                    obj.value
                )
            );
    }

    updateAvatar (avatar: File): Observable<UploadFileState>
    {
        return this.upload('/identicons/update', avatar);
        // const uploadReq = new HttpRequest('POST', `api/upload`, formData, {
        //     reportProgress: true,
        // });
    }
}
